import { useState } from "react";

import { NewsModal } from "components";
import { ArticleModal, NewsDashboardFilters, NewsDashboardTable } from "modules/NewsDashboard/components";
import { useNewsQuery } from "modules/NewsDashboard/hooks";

import type { Article } from "models";

export const NewsDashboard = () => {
  const [article, setArticle] = useState<Article | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [viewArticle, setViewArticle] = useState<Article | null>(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  const { isLoading, articles, nb_items, nb_pages, refetch: refetchArticles } = useNewsQuery();

  const handleOpenEditModal = (article: Article) => {
    setArticle(article);
    setIsModalOpen(true);
  };

  const handleOpenCreateModal = () => {
    setArticle(null);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setArticle(null);
  };

  const handleViewArticle = (article: Article) => {
    setViewArticle(article);
    setIsViewModalOpen(true);
  };

  const handleCloseViewModal = () => {
    setIsViewModalOpen(false);
    setViewArticle(null);
  };

  return (
    <>
      <NewsDashboardFilters onOpenCreateModal={handleOpenCreateModal} />
      <NewsDashboardTable
        articles={articles}
        nb_items={nb_items}
        nb_pages={nb_pages}
        isLoading={isLoading}
        onRowClick={handleViewArticle}
        onOpenModal={handleOpenEditModal}
      />
      <ArticleModal article={article} isOpen={isModalOpen} onClose={handleCloseModal} refetchArticles={refetchArticles} />
      <NewsModal article={viewArticle} isOpen={isViewModalOpen} onClose={handleCloseViewModal} />
    </>
  );
};
